<template>
    <main class="main-content" id="main-content">
        <div class="container">
          <section class="section">
            <page-header>
                <template v-slot:pageTitle>
                  {{$t("changeTariffPlan")}}
                </template>
            </page-header>
            <div class="section__body">
              <div class="change-tariff">
                <div class="change-tariff__header box bg-white">
                  <div class="row no-gutters">
                    <div class="col-12 col-lg-5">
                      <div class="tariff-info">
                        <div class="tariff-info__title section__title section__title_style3">{{$t("tariffPlan")}}</div>
                        <div class="tariff-info__title section__title section__title_style4 color-green">{{contractObj ? contractObj[0].ProductObject[0].tariff : $t("unknown")}}</div>
                        <ul class="list list_unstyled tariff-info__params">
                          <li class="list__item">
                            <div class="list__title color-gray">{{$t("internet")}}:</div>
                            <div class="list__value">150 Мбит/c</div>
                          </li>
                          <li class="list__item">
                            <div class="list__title color-gray">{{$t("tv")}}:</div>
                            <div class="list__value">15+ каналов</div>
                          </li>
                          <li class="list__item">
                            <div class="list__title color-gray">{{$t("telephony")}}:</div>
                            <div class="list__value">{{$t("connected")}}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-12 col-lg-7">
                      <div class="filter-block color-white bg-green">
                        <div class="filter-block__header">
                          <div class="filter-block__icon svg-icon" aria-hidden="true">
                            <svg role="img" width="20" height="20" aria-hidden="true">
                              <use xlink:href="#svg-icon-filter"></use>
                            </svg>
                          </div>
                          <div class="filter-block__title section__title section__title_style3">{{$t("chooseTariffPlan")}}</div>
                        </div>
                        <div class="filter-block__body">
                          <div class="row justify-content-between align-items-center">
                            <div class="col-12 col-md-auto">
                              <div class="filter-category">
                                <div class="filter-category__icon svg-icon" aria-hidden="true">
                                  <svg role="img" width="50" height="50" aria-hidden="true">
                                    <use xlink:href="#svg-icon-internet"></use>
                                  </svg>
                                </div>
                                <div class="filter-category__content">
                                  <div class="filter-category__title">{{$t("internet")}}</div>
                                  <div class="filter-category__dropdown dropdown">
                                    <button class="link" type="button" id="dropdown-internet" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{$t("select")}}</button>
                                    <div class="dropdown-menu" aria-labelledby="dropdown-internet">
                                      <!-- <form method="post" name="form-dropdown-internet"> -->
                                        
                                        <ul class="list list_unstyled checkbox-list">
                                          <li v-for="internetSpeed in internetSpeedList" :key="internetSpeed" class="list__item checkbox">
                                            <label class="checkbox__label" :for="'chb-internet-'+internetSpeed">
                                              <input class="checkbox__hidden" type="radio" :id="'chb-internet-'+internetSpeed" v-model="checkedInternet" :name="internetSpeed" :value="internetSpeed"><span class="checkbox__custom svg-icon" aria-hidden="true">
                                                <svg role="img" width="10" height="10">
                                                  <use xlink:href="#svg-icon-check"></use>
                                                </svg></span><span class="checkbox__title">{{internetSpeed}} Мбит/c</span>
                                            </label>
                                          </li>
                                        </ul>
                                      <!-- </form> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-auto">
                              <div class="filter-category">
                                <div class="filter-category__icon svg-icon" aria-hidden="true">
                                  <svg role="img" width="50" height="50" aria-hidden="true">
                                    <use xlink:href="#svg-icon-tv"></use>
                                  </svg>
                                </div>
                                <div class="filter-category__content">
                                  <div class="filter-category__title">{{$t("tv")}}</div>
                                  <div class="filter-category__dropdown dropdown">
                                    <button class="link" type="button" id="dropdown-tv" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{tv ? tv : 50}}+ каналов</button>
                                    <div class="dropdown-menu" aria-labelledby="dropdown-tv">
                                      <form method="post" name="form-dropdown-tv">
                                        <ul class="list list_unstyled checkbox-list">
                                          <li v-for="tvChanel in tvChanelList" :key="tvChanel" class="list__item checkbox">
                                            <label class="checkbox__label" :for="'chb-tv-'+tvChanel">
                                              <input class="checkbox__hidden" v-model="tv" :id="'chb-tv-'+tvChanel" type="radio" :name="tvChanel" :value="tvChanel"><span class="checkbox__custom svg-icon" aria-hidden="true">
                                                <svg role="img" width="10" height="10">
                                                  <use xlink:href="#svg-icon-check"></use>
                                                </svg></span><span class="checkbox__title">{{tvChanel}}+ каналов</span>
                                            </label>
                                          </li>
                                        </ul>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-12 col-md-auto">
                              <div class="filter-category">
                                <div class="filter-category__icon svg-icon" aria-hidden="true">
                                  <svg role="img" width="50" height="50" aria-hidden="true">
                                    <use xlink:href="#svg-icon-telephony"></use>
                                  </svg>
                                </div>
                                <div class="filter-category__content">
                                  <div class="filter-category__title">{{$t("telephony")}}</div>
                                  <div class="filter-category__dropdown dropdown">
                                    <button class="link" type="button" id="dropdown-telephony" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{telephony ? $t("connected") : $t("notConnected")}}</button>
                                    <div class="dropdown-menu" aria-labelledby="dropdown-telephony">
                                      <form method="post" name="form-dropdown-telephony">
                                        <ul class="list list_unstyled checkbox-list">
                                          <li class="list__item checkbox">
                                            <label class="checkbox__label" for="chb-telephony-1">
                                              <input class="checkbox__hidden" id="chb-telephony-1" type="checkbox" v-model="telephony" name="chb-telephony-1"><span class="checkbox__custom svg-icon" aria-hidden="true">
                                                <svg role="img" width="10" height="10">
                                                  <use xlink:href="#svg-icon-check"></use>
                                                </svg></span><span class="checkbox__title">{{$t("connected")}}</span>
                                            </label>
                                          </li>
                                        </ul>
                                      </form>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="change-tariff__body">
                  <div class="row">
                    <new-tariff v-for="tariff in sortedTariff" :tariff="tariff" :key="tariff.id" @selectTariff="setTariff"></new-tariff>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
    </main>
    <!-- Смена тарифного плана-->
    <div class="modal fade modal_message" ref="modalSuccess" aria-label="Select tariff" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title section__title section__title_style3">
              {{$t("respApplication")}}
            </div>
            <button class="btn svg-icon modal-close" type="button" data-dismiss="modal" @click="closeModal" :aria-label='$t("close")'>
              <svg role="img" width="14" height="14" aria-hidden="true">
                <use xlink:href="#svg-icon-close"></use>
              </svg>
            </button>
          </div>
          <div class="modal-body">
            <div class="section__description color-green">
              {{$t("respApplication2")}}
            </div>
          </div>
        </div>
      </div>
    </div>  
</template>
<script>
import PageHeader from "@/components/PageHeader";
import NewTariff from "@/components/NewTariff";
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  components: {
    PageHeader,
    NewTariff
  },
  data() {
    return {
      preloader: document.querySelector('.preloader'),
      loaded: false,
      checkedInternet: '',
      tv: '',
      telephony: false,
      showModal: true,
    }
  },
  computed: {
    ...mapGetters({
      // personalData: 'personaldata/personalData',
      contractObj: 'personaldata/contractObject',
      profile: 'profile/profileData',
      tariffs: 'tariff/tariffs',
      internetSpeedList: 'tariff/internetSpeedList',
      tvChanelList: 'tariff/tvChanelList',
    }),
    sortedTariff(){
      let result = this.tariffs
      if(this.checkedInternet !== ''){
        result = result.filter(item => item?.internet?.internetSpeed >= this.checkedInternet);
      }
      if(this.tv !== ''){
        result = result.filter(item => item?.television?.channelCount >= this.tv);
      }
      if(this.telephony){
        result = result.filter(item => item?.phoneIncluded);
      }
      return result
    },
  },
  methods: { 
    ...mapActions({
      // getPersonalData: 'personaldata/getPersonalData',
      getTariffs: 'tariff/getAllTariffs',
      selectTariff: 'tariff/selectTariff'
    }),
    showPreloader() {
      this.preloader.classList.remove('d-none')
    },
    hidePreloader() {
      this.preloader.classList.add('d-none');
    },
    isEmpty(obj) {
      for (let key in obj) {
        return false;
      }
      return true;
    },
    openModal() {
      this.$refs.modalSuccess.classList.add('show-modal');
    },
    setTariff(tariff){
      let selectedTariff = {
        "old_tarif": this.contractObj[0].ProductObject[0].idTariff || '',
        "new_tarif": tariff.id, 
        "iin": this.profile?.profile?.iin
      }
      this.selectTariff(selectedTariff).then((resp) => {
        if (resp === 200){
          this.openModal()
        }else{
          toastr.error(this.$t("isError"));
        }
      })	
    },
    closeModal(){
      this.$refs.modalSuccess.classList.remove('show-modal')
    }
  },
  created() {
    this.showPreloader()
    this.getTariffs().then(res => {
      if (res === 200) {
        this.hidePreloader()
        this.loaded = true
      } else if (res === 404) {
        this.$router.push({name: '404'})
        this.hidePreloader()
      }
    });
  }
}
</script>
<style scoped>
  .show-modal{
    display: block !important;
    opacity: 1 !important;
    background: rgba(255,255,255,.5);
  }
  .list__item{
    margin-bottom: 5px;
  }
</style>